<template>
    <select :name="name">
        <!-- The select2 docs say you must NOT have an empty option to show placeholder on multiple select,
                but testing shows that the placeholder doesn't work if you don't have it...
        -->
        <option v-if="multiple === false"></option>
    </select>
</template>

<script>
import { isEqual } from 'lodash';
    export default {
        name: "select2-group",
        emits: ['update:modelValue', 'input'],
        compatConfig: { COMPONENT_V_MODEL: false },
        props: {
            name: String,
            options: Object,
            modelValue: {
                type: [Array, Number, Object, String]
            },
            // Width (percent is appended)
            width: {
                type: String,
                default: '100',
            },
            selectableGroups: { type: Boolean, default: false},
            allowClear: {type: Boolean, default: false},
            // Tags creates new options from text input by the user
            tags: {type: Boolean, default: false},    // https://select2.org/tagging
            // Multiple set to true allows users to select multiple items
            multiple: {type: Boolean, default: false},
            // Placeholder
            placeholder: {type: String, default: ''},
            closeOnSelect: {type: Boolean, default: false}
        },
        data() {
            return {
                groups: {},
                recentUpdatedValue: false,
                updateTimeInterval: 100,
                selectedValue: [],
            }
        },
        mounted() {
            this.buildSelect2()
        },
        methods : {
            buildSelect2() {
                let vm = this;
                this.convertPluckToSelect2(this.options);

                $(this.$el)
                    .select2({
                        data: this.groups,
                        tags: this.tags,
                        name: this.name,
                        multiple: this.multiple ? 'multiple' : '',
                        placeholder: this.placeholder,
                        width: this.width + '%',
                        containerCssClass: '',
                        allowClear: this.allowClear,
                        closeOnSelect: this.closeOnSelect,
                        templateResult: function(item) {
                            if(typeof item.children != 'undefined') {

                                const el = $('<span class="select2_optgroup">' + item.text + '</span>');

                                el.click(function() {
                                    $(vm.$el).find('optgroup[label="' + $(this).text() + '"] option').prop(
                                        'selected',
                                        $(item.element).find('option').length - $(item.element).find('option:selected').length
                                    );
                                    $(vm.$el).change();
                                    $(vm.$el).select2('close');
                                    setTimeout(() => {
                                        $(vm.$el).select2('open');
                                    }, 0);
                                });

                                el.mouseover(function() {
                                    $('li.select2-results__option--highlighted').removeClass('select2-results__option--highlighted');
                                });
                                el.hover(function() {
                                    el.addClass('select2_optgroup_hovered');
                                }, function() {
                                    el.removeClass('select2_optgroup_hovered');
                                });
                                return el;
                            }
                            return item.text;
                        }
                    })
                    .on("change", function() {
                        vm.$emit("update:modelValue", $(vm.$el).val());
                        vm.$emit("input", $(vm.$el).val());
                    })
                    .trigger("change");

                $(this.$el).val(this.selectedValue).trigger('change.select2');
            },
            convertPluckToSelect2(input){
                if (!input) {
                    this.groups = []
                    return
                }
                let newOptions = [];
                this.selectedValue = [];
                for(let [groupName, group] of Object.entries(input)) {
                    let option = {
                        text: groupName,
                        children: [],
                    }
                    for (let [key, value] of Object.entries(group)) {
                        let selected = false
                        if (this.modelValue instanceof Array) {
                            selected = this.modelValue.includes(key) || this.modelValue.includes(Number.parseInt(key))

                        }
                        else if (this.modelValue instanceof Object) {
                            selected = _.has(this.modelValue, key)
                        }
                        else {
                            selected = this.modelValue == key;
                        }
                        option.children.push({
                            id: key,
                            text: value,
                            selected: selected,
                        });
                        if(selected){
                          this.selectedValue.push(key)
                        }
                    }
                    newOptions.push(option);
                }
                this.groups = newOptions;
            },
            destroySelect2() {
                $(this.$el)
                        .off()
                        .select2("destroy");
                // We empty out all child elements (options and optgroups) to ensure we don't get
                // any duplicates!
                $(this.$el)
                        .empty()
                        .trigger("change.select2");
            },
        },
        watch: {
            // TODO: Update this to work correctly with the expanded options / plucktoselect2 code
            modelValue: function(value, oldVal) {
                if (this.recentUpdatedValue) {
                    return
                }
                // update value
                $(this.$el)
                        .val(value)
                        .trigger("change");
                this.recentUpdatedValue = true
                let comp = this
                setTimeout(function() {
                    comp.recentUpdatedValue = false
                }, 100)
            },
            options: function(value, oldVal) {
              if(!isEqual(value, oldVal)){
                this.destroySelect2()
                this.buildSelect2()
              }
            },
        },
        unmounted() {
            this.destroySelect2()
        },
    }
</script>

<style>

.select2_optgroup_selected {
    background-color: #ddd;
}
.select2_optgroup_hovered {
    color: #FFF;
    background-color: #5897fb !important;
    cursor: pointer;
}
strong.select2-results__group {
    padding: 0 !important;
}
.select2_optgroup {
    display: block;
    padding: 6px;
}
.select2-search--inline .select2-search__field::placeholder {
    color: #9ca3af;
    opacity: 1;
}
/* Keep the open dropdown above modals (which use high z-index stacking contexts). */
.select2-container--open {
    z-index: 1200;
}

</style>